var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (allAnswers, continueBtnText, doneText, game, hasNarration, hasPrompt, i18n, message, prompt, submitUp, title, undefined) {
if ( game && game.timer && game.timer.limit > 0 && !game.timer.isDisabled)
{
buf.push("<div class=\"full-screen\"><div class=\"game-stepper text-lg text-bold\"></div><div class=\"game-progress\"><div class=\"game-progress-bar\"></div></div></div>");
}
buf.push("<div class=\"content-fill\"><div class=\"block-v-md content-ver text-md content-fit\">");
if ( title)
{
buf.push("<h2 class=\"fade-in\">" + (null == (jade_interp = title) ? "" : jade_interp) + "</h2>");
}
buf.push("<div class=\"row\">");
if ( message.content)
{
buf.push("<div class=\"col-lg-10 col-sm-12\">");
if ( message.sender)
{
buf.push("<h4 class=\"fade-in block-v-sm\">" + (null == (jade_interp = message.sender) ? "" : jade_interp) + "</h4>");
}
buf.push("<div class=\"message message--question chat-msg quote quote-dk pull-left\"><div class=\"quote-content\"><div class=\"chat-msg-elli\"><span class=\"bullet delay-1\">&bullet;</span><span class=\"bullet delay-2\">&bullet;</span><span class=\"bullet delay-3\">&bullet;</span></div><div class=\"chat-msg-text\">" + (null == (jade_interp = message.content) ? "" : jade_interp) + "</div></div></div></div>");
}
if ( message.responder)
{
buf.push("<div class=\"col-sm-12 block-v-sm text-right chat-responder delay-4\"><h4>" + (null == (jade_interp = message.responder) ? "" : jade_interp) + "</h4></div>");
}
buf.push("<div class=\"col-md-10 col-md-offset-2 col-sm-12\">");
// iterate allAnswers
;(function(){
  var $$obj = allAnswers;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var answer = $$obj[$index];

buf.push("<div" + (jade.attr("data-id", answer.id, true, false)) + (jade.cls(['message','message--answer','chat-msg','quote','quote-lt','pull-right','text-right','selectable',([
              "delay-" + (answer.delay) + "",
              answer.isCorrect ? "correct" : "incorrect"
            ].join(" "))], [null,null,null,null,null,null,null,null,true])) + "><div class=\"quote-content\">" + (null == (jade_interp = answer.text) ? "" : jade_interp) + "</div></div>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var answer = $$obj[$index];

buf.push("<div" + (jade.attr("data-id", answer.id, true, false)) + (jade.cls(['message','message--answer','chat-msg','quote','quote-lt','pull-right','text-right','selectable',([
              "delay-" + (answer.delay) + "",
              answer.isCorrect ? "correct" : "incorrect"
            ].join(" "))], [null,null,null,null,null,null,null,null,true])) + "><div class=\"quote-content\">" + (null == (jade_interp = answer.text) ? "" : jade_interp) + "</div></div>");
    }

  }
}).call(this);

buf.push("</div></div></div></div><div" + (jade.cls(['slide-footer','block-v-lg',submitUp ? "slide-footer--up slide-down" : "slide-up"], [null,null,true])) + ">");
if ( hasPrompt)
{
buf.push("<div class=\"slide-footer-touched\"><div class=\"btn btn-muted btn-done text-ellipsis\">" + (null == (jade_interp = doneText) ? "" : jade_interp) + "</div></div>");
if ( typeof prompt === "string")
{
buf.push("<div class=\"slide-footer-prompt text-uppercase text-bold\"><div class=\"slide-footer-prompt-content content-ver\">" + (null == (jade_interp = prompt) ? "" : jade_interp) + "</div></div>");
}
}
else
{
buf.push("<div class=\"slide-footer-prompt\"><div class=\"btn btn-muted btn-done text-ellipsis content-ver\">" + (null == (jade_interp = continueBtnText || i18n("buttons.continue")) ? "" : jade_interp) + "</div></div>");
}
if ( hasNarration)
{
buf.push("<div class=\"slide-footer-narration\"><div class=\"narration-progress btn btn-muted\"><div class=\"narration-progress-bar\"></div><div class=\"wave-ellipse\"><span class=\"bullet delay-1 block-inline\">&bullet;</span><span class=\"bullet delay-2 block-inline\">&bullet;</span><span class=\"bullet delay-3 block-inline\">&bullet;</span></div></div></div>");
}
buf.push("</div>");}.call(this,"allAnswers" in locals_for_with?locals_for_with.allAnswers:typeof allAnswers!=="undefined"?allAnswers:undefined,"continueBtnText" in locals_for_with?locals_for_with.continueBtnText:typeof continueBtnText!=="undefined"?continueBtnText:undefined,"doneText" in locals_for_with?locals_for_with.doneText:typeof doneText!=="undefined"?doneText:undefined,"game" in locals_for_with?locals_for_with.game:typeof game!=="undefined"?game:undefined,"hasNarration" in locals_for_with?locals_for_with.hasNarration:typeof hasNarration!=="undefined"?hasNarration:undefined,"hasPrompt" in locals_for_with?locals_for_with.hasPrompt:typeof hasPrompt!=="undefined"?hasPrompt:undefined,"i18n" in locals_for_with?locals_for_with.i18n:typeof i18n!=="undefined"?i18n:undefined,"message" in locals_for_with?locals_for_with.message:typeof message!=="undefined"?message:undefined,"prompt" in locals_for_with?locals_for_with.prompt:typeof prompt!=="undefined"?prompt:undefined,"submitUp" in locals_for_with?locals_for_with.submitUp:typeof submitUp!=="undefined"?submitUp:undefined,"title" in locals_for_with?locals_for_with.title:typeof title!=="undefined"?title:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}